import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Container, Grid, InputAdornment, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import fc from '../firebaseConfig';
import 'boxicons';
import Navbar from './Navbar';
import { format } from 'date-fns';

const db = getDatabase(fc);

const TableData = () => {
  const [clientsData, setClientsData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showIds, setShowIds] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loggedIn = localStorage.getItem('LOGGED_IN');
    if (loggedIn !== 'true') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const clientsRef = ref(db, 'clients');
      onValue(clientsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const dataArray = Object.entries(data).map(([id, item]) => ({ id, ...item }));
          const sortedClients = dataArray.sort((a, b) => a.name.localeCompare(b.name));
          setClientsData(sortedClients);
        }
      });

      const employeesRef = ref(db, 'employees');
      onValue(employeesRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const dataArray = Object.entries(data).map(([id, item]) => ({ id, ...item }));
          setEmployeesData(dataArray);
        }
      });

      const eventsRef = ref(db, 'events');
      onValue(eventsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const dataArray = Object.entries(data).map(([id, item]) => ({ id, ...item }));
          setEventsData(dataArray);
        }
      });
    };

    fetchData();
  }, []);

  const filterData = (data) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return data.filter(item =>
      Object.values(item).some(value =>
        typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchTerm)
      )
    );
  };

  const noResults = (data) => filterData(data).length === 0;

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return `${format(date, 'dd.MM.yyyy')} ${format(date, 'HH:mm')}`;
  };

  const getClientNameById = (clientId) => {
    const client = clientsData.find(client => client.id === clientId);
    return client ? client.name : '';
  };

  return (
    <div>
      <Navbar/>
      <Container style={{ width: '89%', marginBottom: '15rem', marginTop: '3rem' }}>
        <h2 style={{ marginTop: '5rem' }}>Tabela Danych</h2>
        <TextField
          style={{ marginBottom: '3rem' }}
          label="Szukaj"
          variant="outlined"
          fullWidth
          margin="normal"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'black',
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <box-icon name='search' color='black'></box-icon>
              </InputAdornment>
            ),
          }}
        />

        <Grid container spacing={3} direction="column" alignItems="center">
          {/* Clients Table */}
          <Grid item xs={12}>
            <h3 style={{ color: noResults(clientsData) ? 'red' : 'black' }}>Klienci</h3>
            <TableContainer
              component={Paper}
              style={{
                width: '65rem',
                overflow: 'auto',
                backgroundColor: 'inherit'
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(clientsData) ? 'red' : 'black' }}>ID</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(clientsData) ? 'red' : 'black' }}>Imię i Nazwisko</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(clientsData) ? 'red' : 'black' }}>Numer telefonu</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {noResults(clientsData) ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center" style={{ border: '1px solid', borderColor: 'red', color: 'red' }}>
                        Brak wyników
                      </TableCell>
                    </TableRow>
                  ) : (
                    filterData(clientsData).map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.id}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.name}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.number}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Employees Table */}
          <Grid item xs={12}>
            <h3 style={{ color: noResults(employeesData) ? 'red' : 'black' }}>Pracownicy</h3>
            <TableContainer
              component={Paper}
              style={{
                width: '65rem',
                overflow: 'auto',
                backgroundColor: 'inherit'
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(employeesData) ? 'red' : 'black' }}>ID</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(employeesData) ? 'red' : 'black' }}>Imię i Nazwisko</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(employeesData) ? 'red' : 'black' }}>Numer telefonu</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {noResults(employeesData) ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center" style={{ border: '1px solid', borderColor: 'red', color: 'red' }}>
                        Brak wyników
                      </TableCell>
                    </TableRow>
                  ) : (
                    filterData(employeesData).map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.id}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.name}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.number}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Events Table */}
          <Grid item xs={12}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: noResults(eventsData) ? 'red' : 'black', marginRight: '80%' }}>Wydarzenia</h3>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showIds}
                    onChange={() => setShowIds(!showIds)}
                    color="primary"
                  />
                }
                label="Pokaż ID"
              />
            </div>
            <TableContainer
              component={Paper}
              style={{
                width: '65rem',
                overflow: 'auto',
                backgroundColor: 'inherit'
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Tytuł usługi</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Rozpoczęcie</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Zakończenie</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Imię i Nazwisko Pracownika</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Numer telefonu Pracownika</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Imię i Nazwisko Klienta</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Numer telefonu Klienta</TableCell>
                    <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>Kolor</TableCell>
                    {showIds && (
                      <>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: noResults(eventsData) ? 'red' : 'black' }}>ID pracownika</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {noResults(eventsData) ? (
                    <TableRow>
                      <TableCell colSpan={showIds ? 8 : 7} align="center" style={{ border: '1px solid', borderColor: 'red', color: 'red' }}>
                        Brak wyników
                      </TableCell>
                    </TableRow>
                  ) : (
                    filterData(eventsData).map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.title}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{formatDate(row.startDate)}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{formatDate(row.endDate)}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.employeeName}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.employeeNumber}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{getClientNameById(row.clientId)}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.phone}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid', borderColor: 'black', padding: 0 }}>
                          <div style={{
                            width: '30px',
                            height: '30px',
                            backgroundColor: row.color,
                            border: '1px solid black',
                            borderRadius: '4px',
                            alignItems: 'center', 
                            justifyContent: 'center',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                          }} />
                        </TableCell>
                        {showIds && (
                          <>
                            <TableCell align="center" style={{ border: '1px solid', borderColor: 'black' }}>{row.employeeId}</TableCell>
                          </>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default TableData;
